<template>
<v-flex xs12 sm10 offset-sm1 md10 offset-md1 lg8 offset-lg2>
    <!-- Alert -->
    <Alert v-if="alertType !== ''" :atype="alertType" :message="message" :visibility="visibility" />

    <v-progress-linear v-if="progressbar" :indeterminate="true"></v-progress-linear>

    <v-flex xs12>

        <Tags class="mt-3 mb-3" :products="products" @navigateTo="goToSlide"/>

        <!--carousel-->
        <carousel-3d @after-slide-change="onAfterSlideChange" ref="productCarousel" animationSpeed="1500" class="slider" :count="products.length" :controls-visible="true" :height=height :width=600>

            <slide v-for="(product, i) in products" :key="i" :index="i" :style="`height:auto; background:transparent;`">

                <div class="bg-transparent">

                    <v-card class="semi-transparent-7-bg">

                        <v-card-text class="semi-transparent-7-bg">

                            <ProductCarousel :product="product" @ImageIsLoaded='loaded'/>

                            <ExpansionPanel :product="product" @show="enable"/>

                            <DownloadButton :product="product"/>

                        </v-card-text>

                        <v-card-actions class=" game-card-action semi-transparent-7-bg">

                            <Buttons :product="product"/>

                        </v-card-actions>

                    </v-card>

                </div>

            </slide>

        </carousel-3d>

        <!--snackbar-->
        <Snackbar :color="'green'" :icon="'done_all'" :text="$t('shared.copied')" :show="snackbar" @update-snackbar="snackbar = false" />

    </v-flex>
</v-flex>
</template>

<script>
//use carousel 3D locally
import {Carousel3d, Slide} from 'vue-carousel-3d';
import Tags from '@/components/Games/Tags.vue';
import ProductCarousel from '@/components/Games/ProductCarousel.vue';
import ExpansionPanel from '@/components/Games/ExpansionPanel.vue';
import Snackbar from '@/components/Reusable/Snackbar.vue';
import Alert from "@/components/Reusable/Alert.vue";
import Api from "@/api";
import Buttons from '@/components/Games/Buttons.vue';
import DownloadButton from '@/components/Games/DownloadButton.vue';
import _ from 'lodash';

export default {
    name: 'Game',
    data() {
        return {
            alertType: "",
            message: "",
            visibility: false,
            progressbar: false,
            products: [{
                id:1,
                name: 'Main Wallet'
            }],
            height: 700,
            snackbar: false,
            initResize: false
        }
    },
    //use carousel 3D locally
    components: {
        Alert,
        Carousel3d,
        Slide,
        Tags,
        ExpansionPanel,
        Snackbar,
        Buttons,
        ProductCarousel,
        DownloadButton
    },
    mounted: async function() {

        await this.getProducts();

        let prevs = document.getElementsByClassName("prev");

        for(let p = 0; p < prevs.length; p++) {

            prevs[p].style.color = "rgba(255, 255, 255, 0.75)";

        }

        let nexts = document.getElementsByClassName("next");

        for(let n = 0; n < nexts.length; n++) {

            nexts[n].style.color = "rgba(255, 255, 255, 0.75)";

        }

        window.addEventListener('resize', this.onResize);

    },
    methods: {
        enable(value) {

            this.snackbar = value;

        },
        getImgUrl(img) {

            var images = require.context('@/assets/', false, /\.png$/);

            return images('./' + img + ".png");

        },
        async getProducts() {

            this.progressbar = true;

            let res = null;

            if(this.$store.getters.user_token != "") {

                res = await Api.getProductsMember({
                    access_token: this.$store.getters.user_token
                });

            } else {

                res = await Api.getProducts();

            }

            this.progressbar = false;

            let isLogin = this.$store.getters.user_token != "";

            let currentInstance = this;

            if (res && 'success' in res && res.success === true) {

                this.products = await res.data.filter(function(product) {
                    // Wallet Show only when logged-in
                    if(product.id == 1) {
                        return isLogin;
                    } else {
                        return true;
                    }
                });

                this.products = this.products.map(function(product){

                    if(product.id == 1) {

                        product.logo = currentInstance.getImgUrl('wallet');

                    }

                    if(product.id != 1 && product.logo == '') {

                        product.logo = currentInstance.getImgUrl('coming-soon');

                    }

                    if(product.player && product.player.length > 0) {

                        product.username = product.player[0].username;

                        product.password = product.player[0].password;

                    }

                    return product;
                });

            } else {

                this.visibility = true;

                this.message = res.message;

                this.alertType = "error";

                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})

                }

            }
        },
        arrayToObject(array, key) {

            return array.reduce((obj, item) => {
                obj[item[key]] = item;
                return obj;
            }, {});

        },
        goToSlide(value) {

            this.$refs.productCarousel.goSlide(value);

        },
        onResize: _.debounce(function(){

            // resize height of carousel-3d-slide
            // download buttons + action button default height 260px
            let fixHeight = 120;

            let logos = document.querySelectorAll('.slide-card-child-logo');

            let childCarousel = document.querySelectorAll('.v-card__text');

            let logoHeight = 0;

            let childCarouselHeight = 0;

            if (childCarousel.length) {

                for (let cc = 0; cc < childCarousel.length; cc++) {

                    childCarouselHeight = (childCarouselHeight < childCarousel[cc].offsetHeight) ? childCarousel[cc].offsetHeight : childCarouselHeight;

                }
            }

            if (logos.length) {

                for (let lh = 0; lh < logos.length; lh++) {

                    logoHeight = (logoHeight < logos[lh].offsetHeight) ? logos[lh].offsetHeight : logoHeight;

                }
            }

            //console.log(`child:${childCarouselHeight} + logo:${logoHeight} + fix:${fixHeight}`);

            let sliderEL = document.querySelectorAll('.carousel-3d-container');

            if (sliderEL.length) {

                for (let se = 0; se < sliderEL.length; se++) {

                    // min height
                    let computeHeight = childCarouselHeight + logoHeight + fixHeight;

                    let finalHeight = 700 > computeHeight ? 700 : computeHeight;

                    let elFinalHeight = finalHeight > computeHeight ? finalHeight : computeHeight;

                    // only replace height if not same
                    if (elFinalHeight != sliderEL[se].style.minHeight) {

                        sliderEL[se].style.minHeight = elFinalHeight + 'px';

                        sliderEL[se].style.height = elFinalHeight + 'px';
    
                    }

                }
            }
        }, 350),
        onAfterSlideChange() {

            this.onResize();

        },
        loaded(){

            this.onResize();

        }
    }
}
</script>


<style>
.v-card__actions .v-btn + .v-btn {
    margin-left: 0px !important;
}
</style>

<style scoped>
.font-size {
    font-size: 12px;
}
.v-card__text {
    padding: 2px 16px;
}

.carousel-3d-slide {
    border-color: rgba(0,0,0,.0);
}

.v-card {
    border-radius: 3px;
}

.game-card-action{
    padding: 0px;
}

.bg-transparent {
    background-color:transparent;
}

.slide-card-parent {
    position: relative;
    transform: translateY(50%);
    z-index: 2;
}

.carousel-3d-slide img {
    width: 50%;
    margin: auto;
}

.slide-card-child-logo {
    z-index: 100;
    min-width:50%;
    display:flex;
    justify-content: center;
    align-items: center;
    -webkit-filter: drop-shadow(2px 2px 0px white) drop-shadow(-2px -2px 0px white) drop-shadow(-2px 2px 0px white) drop-shadow(2px -2px 0px white) drop-shadow(-2px -2px 0px grey) drop-shadow(2px -2px 0px grey);
    filter: drop-shadow(2px 2px 0px white) drop-shadow(-2px -2px 0px white) drop-shadow(-2px 2px 0px white) drop-shadow(2px -2px 0px white) drop-shadow(-2px -2px 0px grey) drop-shadow(2px -2px 0px grey);
}

.carousel-3d-container {
    margin-top: 0px;
}
</style>
